import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import PaymentTerminal from '../../plugins/payment-terminal';
import { environment } from '../../environments/environment';
import { isEmpty } from 'lodash';

@Injectable({providedIn: 'root'})
export class TerminalConfiguredGuard {
  constructor(private readonly router: Router) {
  }

  async canActivate(): Promise<boolean | UrlTree> {
    if (!environment.runOnAndroidPaymentTerminal) {
      return true;
    }

    const { hasConfiguredTerminal } = await PaymentTerminal.checkHasConfiguredTerminal();

    if (hasConfiguredTerminal) {
      return true;
    }

    const { availableTerminals } = await PaymentTerminal.getAvailableTerminals();

    if (isEmpty(availableTerminals)) {
      return true;
    }

    return this.router.parseUrl('/terminal-configuration');
  }

  canActivateChild() {
    return this.canActivate();
  }
}
